// extracted by mini-css-extract-plugin
export var container = "ExpandedKeg-module--container--dd634";
export var desktopExpandedKeg = "ExpandedKeg-module--desktopExpandedKeg--c05cf";
export var mobileExpandedKeg = "ExpandedKeg-module--mobileExpandedKeg--3812b";